.arrow::before,
.arrow::after {
  content: '';
  position: absolute;
}

.arrow[data-placement='top']::before {
  margin-top: 1px;
}
.arrow.dark[data-placement='top']::after {
  margin-top: -1px;
}

.arrow[data-placement='bottom']::before {
  margin-bottom: 1px;
}
.arrow.dark[data-placement='bottom']::after {
  margin-bottom: 1px;
}

.arrow[data-placement='left']::before {
  margin-left: 1px;
}
.arrow.dark[data-placement='left']::after {
  margin-left: -1px;
}

.arrow[data-placement='left']::before {
  margin-left: 1px;
}
.arrow.dark[data-placement='left']::after {
  margin-left: 1px;
}

.arrow[data-placement='right']::before {
  margin-right: 1px;
}
.arrow.dark[data-placement='right']::after {
  margin-right: -1px;
}

.arrow[data-placement='right']::before {
  margin-right: 1px;
}
.arrow.dark[data-placement='right']::after {
  margin-right: 1px;
}

.arrow[data-placement='top']::after,
.arrow[data-placement='top']::before {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top-width: 7px;
  border-top-style: solid;
  top: 100%;
  translate: -50%;
}

.arrow.dark[data-placement='top']::after,
.arrow.dark[data-placement='top']::before {
  border-top-color: var(--color__gray-800);
}

.arrow.light[data-placement='top']::before {
  border-top-color: var(--color__gray-300);
}
.arrow.light[data-placement='top']::after {
  border-top-color: var(--color__gray-100);
}

.arrow[data-placement='bottom']::after,
.arrow[data-placement='bottom']::before {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom-width: 7px;
  border-bottom-style: solid;
  bottom: 100%;
  translate: -50%;
}

.arrow.dark[data-placement='bottom']::after,
.arrow.dark[data-placement='bottom']::before {
  border-bottom-color: var(--color__gray-800);
}

.arrow.light[data-placement='bottom']::before {
  border-bottom-color: var(--color__gray-300);
}
.arrow.light[data-placement='bottom']::after {
  border-bottom-color: var(--color__gray-100);
}

.arrow[data-placement='right']::after,
.arrow[data-placement='right']::before {
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right-width: 7px;
  border-right-style: solid;
  right: 100%;
  top: 50%;
  translate: 0 -50%;
}

.arrow.dark[data-placement='right']::after,
.arrow.dark[data-placement='right']::before {
  border-right-color: var(--color__gray-800);
}

.arrow.light[data-placement='right']::before {
  border-right-color: var(--color__gray-300);
}
.arrow.light[data-placement='right']::after {
  border-right-color: var(--color__gray-100);
}

.arrow[data-placement='left']::after,
.arrow[data-placement='left']::before {
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left-width: 7px;
  border-left-style: solid;
  left: 100%;
  top: 50%;
  translate: 0 -50%;
}

.arrow.dark[data-placement='left']::after,
.arrow.dark[data-placement='left']::before {
  border-left-color: var(--color__gray-800);
}

.arrow.light[data-placement='left']::before {
  border-left-color: var(--color__gray-300);
}
.arrow.light[data-placement='left']::after {
  border-left-color: var(--color__gray-100);
}
